// Shorthand for $( document ).ready()
$(function() {
	if ( $('.swiper-about').length > 0 ) {
		const swiperAbout = new Swiper('.swiper-about', {
			loop: true,
		  
			// If we need pagination
			pagination: {
			  el: '.swiper-pagination',
			},
		  
			// Navigation arrows
			navigation: {
			  nextEl: '.swiper-about-next',
			  prevEl: '.swiper-about-prev',
			},
	
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		});
	}


	// SWIPER HERO
	if ( $('.swiper-hero').length > 0 ) {
		const swiperHero = new Swiper('.swiper-hero', {
			loop: true,
		  
			// If we need pagination
			pagination: {
			  el: '.hero-pagination',
			  clickable: true,
			},

			// Navigation arrows
			navigation: {
			  nextEl: '.swiper-hero-next',
			  prevEl: '.swiper-hero-prev',
			},
	
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
		});
		
	}
    // SWIPER HERO


	// SWIPER PRODUCT
	if ( $('.swiper-product').length > 0 ) {
		const swiperProduct = new Swiper('.swiper-product', {
			// loop: true,
		  
			// If we need pagination
			pagination: {
			  el: '.product-pagination',
			  clickable: true,
			},

			// Navigation arrows
			navigation: {
			  nextEl: '.product-next',
			  prevEl: '.product-prev',
			},
	
			// effect: 'fade',
			// fadeEffect: {
			// 	crossFade: true
			// },
		});
		
	}
    // SWIPER PRODUCT


	// SWIPER SERVICE
	if ( $('.swiper-service').length > 0 ) {
		const swiperService = new Swiper('.swiper-service', {
		  loop: true,
		
		  // If we need pagination
		  pagination: {
			el: '.swiper-pagination',
		  },
		
		  // Navigation arrows
		  navigation: {
			nextEl: '.swiper-service-next',
			prevEl: '.swiper-service-prev',
		  },
	
		  // effect: 'fade',
		  // fadeEffect: {
		  //     crossFade: true
		  // },
	  });
	}
  // SWIPER SERVICE

    


  	// SWIPER DETAIL
  	if ( $('.swiper-detail').length > 0 ) {
		  const swiperDetail = new Swiper('.swiper-detail', {
				// If we need pagination
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
			  	// navigation: false,
				// Navigation arrows
				breakpoints: {
					768: {
						navigation: {
							nextEl: '.swiper-detail-next',
							prevEl: '.swiper-detail-prev',
						},
						pagination: false,
					},
				},
		  });
	}
	// SWIPER DETAIL

  	// SWIPER LISTING
  	if ( $('.swiper-listing').length > 0 ) {
		const swiperDetail = new Swiper('.swiper-listing', {
			
			// If we need pagination
			pagination: {
				el: '.swiper-pagination',
			},
		});
  }
  // SWIPER LISTING

	// OFFER SLIDER
	if ( $('.swiper-offer').length > 0 ) {
		let freeModeOffer = false;
		let centerInsufficientSlidesOffer = true;
		const offerContainer = document.querySelector('.swiper-offer .swiper-wrapper');
		if ( offerContainer.childElementCount > 5 && screen.width > 768 ) 
		{
			freeModeOffer = true;
			centerInsufficientSlidesOffer = false;
		}
	
		const swiperOffer = new Swiper('.swiper-offer', {
			preloadImages: false,
			lazy: true,
			// loop: true,
			slidesPerView: 1,
			spaceBetween: 30,
			centerInsufficientSlides: centerInsufficientSlidesOffer,
			freeMode: freeModeOffer,
	
			
			breakpoints: {
				// 640: {
				//     slidesPerView: 2,
				//     spaceBetween: 30,
				// },
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1200: {
					slidesPerView: 5,
					spaceBetween: 30,
				}
			},
		  
			// If we need pagination
			pagination: {
			  el: '.swiper-pagination',
			},
		  
			// Navigation arrows
			navigation: {
			  nextEl: '.swiper-offer-next',
			  prevEl: '.swiper-offer-prev',
			},
		});	
	}
    // OFFER SLIDER


});


// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js